export function cloneStylesheets(targetDocument: Document) {
  // Clone all style and link elements
  const elements = document.querySelectorAll('style, link[rel="stylesheet"]');

  elements.forEach((element) => {
    try {
      targetDocument.head.appendChild(element.cloneNode(true));
    } catch {
      // Skip cross-origin or restricted stylesheets that cannot be cloned
    }
  });

  // Copy all CSS custom properties from :root to the PiP document.
  // Design system tokens (colors, spacing, etc.) are set on :root
  // and won't resolve in the PiP's separate document without this.
  const rootStyles = getComputedStyle(document.documentElement);
  const targetStyle = targetDocument.documentElement.style;

  for (const prop of rootStyles) {
    if (prop.startsWith('--')) {
      targetStyle.setProperty(prop, rootStyles.getPropertyValue(prop));
    }
  }
}
